/** 開発環境向け設定 */
export const environment = {
  /** 本番ビルド判定 */
  production: false,

  /** アプリケーション共通設定 */
  app: {
    /** appFiles API で使用する固定 indexAppCd */
    indexAppCd: 'group-list-hub-manager',
  },

  /** 認証関連設定 */
  auth: {
    /** 無効なセッション時の遷移先 URL */
    invalidSessionRedirectUrl: 'https://garage-ui-net6.garage.ui.nakamenosakura.com/smsp/#/login/applications',
    //'https://inventory-ui.nakamenosakura.com/inventory/top' ProSche無理かも

    /** 期限切れメッセージを表示してから遷移するまでの待機時間（ミリ秒） */
    expiredSessionRedirectDelayMs: 8000,

    /** デバッグ時に自動遷移を停止するか */
    redirectEnabled: true,
  },

  /** inspection 共有 URL 設定 */
  inspectionLink: {
    /** inspection 用の固定パス */
    path: '/inspection',

    /** inspection 画面で表示する既定 View CD */
    defaultViewCd: 3,

    /** 共有 URL の既定有効日数 */
    defaultValidityDays: 365,

    /** inspection で session 有効期限も併せて検証するか */
    enforceSessionExpiryCheck: false,

    /** 軽量トークン難読化に使う固定 salt */
    tokenSalt: 'inspection-link-v1',
  },

  /** 一般 API 設定 */
  api: {
    /** 一般 API の Base URL */
    baseUrl: 'https://api.out.inventory-report.nakamenosakura.com/api/',

    /** マスタ参照 API の Base URL */
    masterBaseUrl: 'https://task.out.inventory-report.nakamenosakura.com/api/',

    /** API パステンプレート群 */
    endpoints: {
      /** 一覧検索 API */
      listSearch: 'list/{reporterId}/search',

      /** 出荷情報 patch API */
      shipPatch: 'ships/{reporterId}/patch',

      /** 入荷情報 patch API */
      incomingPatch: 'incomings/{reporterId}/patch',

      /** ロット情報 patch API */
      lotPatch: 'lots/{reporterId}/patch',

      /** 振分先マスタ検索 API */
      distributionPlaceSearch: 'Tasks/ReporterId/{reporterId}/SearchDistributionPlaceList',
    },
  },

  /** Group 管理 API 設定 */
  groupApi: {
    /** Group 管理 API の固定 Base URL */
    baseUrl: 'https://index-core-front-api.isbe.out.nakamenosakura.com/',

    /** Group JSON の保存先ルート */
    fileSystemRoot: 'groups',

    /** 全 Group 取得で使用する検索パス */
    searchPath: 'groups/*',

    /** targets セクションの識別キー名 */
    keyName: 'targetId',

    /** nodes API の JSON 種別 */
    jsonFileType: 'object',

    /** nodes API の対象オブジェクトパス */
    baseObjectPath: 'targets',

    /** nodes / patch API の secure パラメータ */
    secure: true,

    /** nodes / patch API の waiting パラメータ */
    waiting: true,

    /** Group 管理 API の固定 bucketCode */
    bucketCode: 'inventory-report',

    /** Group 管理 API パステンプレート群 */
    endpoints: {
      /** 単一 Group 作成・取得・削除 */
      data: 'api/appFiles/{indexAppCd}/data/{reporterId}',

      /** 全 Group 取得 */
      list: 'api/appFiles/{indexAppCd}/data/{reporterId}/list',

      /** Group targets 更新・削除 */
      nodes: 'api/appFiles/{indexAppCd}/data/{reporterId}/nodes',

      /** Group 部分更新 */
      patch: 'api/appFiles/{indexAppCd}/data/{reporterId}/patch',
    },
  },

} as const;
